module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-page-layout', {
    attrs: {
      "config": _vm.pageConfig
    }
  }, [(_vm.Data.State === 'draft' || _vm.Data.State === 'cancelled') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": [_vm.Data]
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "收件人："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.ContactName))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "联系人电话："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.ContactPhone))])]), _vm._v(" "), (props.row.StreetAddress === null) ? _c('el-form-item', {
          attrs: {
            "label": "联系地址："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.Province ? props.row.Province.Name : '-') + " " + _vm._s(props.row.City ? props.row.City.Name : '-') + " " + _vm._s(props.row.County ? props.row.County.Name : '-') + " " + _vm._s(props.row.PointOfSales.Name))])]) : _vm._e(), _vm._v(" "), (props.row.StreetAddress !== null) ? _c('el-form-item', {
          attrs: {
            "label": "联系地址："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.Province ? props.row.Province.Name : '-') + " " + _vm._s(props.row.City ? props.row.City.Name : '-') + " " + _vm._s(props.row.County ? props.row.County.Name : '-') + " " + _vm._s(props.row.StreetAddress))])]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流订单",
      "prop": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('el-col', [_vm._v(_vm._s(_vm._f("LogisticsSource")(prop.row.OriginalOrderType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('el-col', [_vm._v(_vm._s(_vm._f("changeDeliveryType")(prop.row.DeliveryType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流费用",
      "prop": "TotalAmount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Data.State === 'shipped' || _vm.Data.State === 'arrived') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": [_vm.Data]
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "收件人："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.ContactName))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "联系人电话："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.ContactPhone))])]), _vm._v(" "), (props.row.StreetAddress === null) ? _c('el-form-item', {
          attrs: {
            "label": "联系地址："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.Province ? props.row.Province.Name : ' ') + " " + _vm._s(props.row.City ? props.row.City.Name : ' ') + " " + _vm._s(props.row.County ? props.row.County.Name : ' ') + " " + _vm._s(props.row.PointOfSales ? props.row.Name : ''))])]) : _vm._e(), _vm._v(" "), (props.row.StreetAddress !== null) ? _c('el-form-item', {
          attrs: {
            "label": "联系地址："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.Province ? props.row.Province.Name : ' ') + " " + _vm._s(props.row.City ? props.row.City.Name : ' ') + " " + _vm._s(props.row.County ? props.row.County.Name : ' ') + " " + _vm._s(props.row.StreetAddress))])]) : _vm._e(), _vm._v(" "), (_vm.Data.State === 'arrived') ? _c('el-form-item', {
          attrs: {
            "label": "签收时间："
          }
        }, [(props.row.ReceivedDate !== null) ? _c('span', [_vm._v(_vm._s(_vm._f("date")(props.row.ReceivedDate, 'YYYY-MM-DD HH:mm:ss')))]) : _vm._e(), _vm._v(" "), (props.row.ReceivedDate === null) ? _c('span', [_vm._v("-")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.Data.State === 'arrived') ? _c('el-form-item', {
          attrs: {
            "label": "等待时间："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.WaitedHours) + "分钟")])]) : _vm._e(), _vm._v(" "), (_vm.Data.State === null) ? _c('el-form-item', {
          attrs: {
            "label": "等待时间："
          }
        }, [_c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.Data.State === 'arrived') ? _c('el-form-item', {
          attrs: {
            "label": "备注："
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("NullShow")(props.row.ArrivalNotes)))])]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流订单",
      "prop": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('el-col', [_vm._v(_vm._s(_vm._f("LogisticsSource")(prop.row.OriginalOrderType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('el-col', [_vm._v(_vm._s(_vm._f("changeDeliveryType")(prop.row.DeliveryType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货时间",
      "prop": "ShippedDate",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("date")(props.row.ShippedDate, 'YYYY-MM-DD HH:mm:ss')))]
      }
    }])
  }), _vm._v(" "), (_vm.Data.State === 'shipped' && _vm.Data.DeliveryType === 'scheduled' || _vm.Data.State === 'arrived' && _vm.Data.DeliveryType === 'scheduled') ? _c('el-table-column', {
    attrs: {
      "label": "预约时间",
      "prop": "ScheduledDate",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("date")(props.row.ScheduledDate, 'YYYY-MM-DD HH:mm:ss')))]
      }
    }])
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流费用",
      "prop": "TotalAmount"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "配送方式",
      "prop": "Carrier"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row.Carrier.Name))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "配送员",
      "prop": "DeliveryEmployee.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "配送员电话",
      "prop": "ContactPhone"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h3', {
    staticStyle: {
      "line-height": "3em"
    }
  }, [_vm._v("物料清单")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": _vm.Data.Lines
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "批次号",
      "prop": "LotCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(props.row.Product.Name))]), _vm._v(" "), _c('el-col', [_vm._v("物料编码:" + _vm._s(props.row.Product.Code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品项"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm._f("ConditionColor")(props.row.Condition.Name)
          }
        }, [_vm._v(_vm._s(props.row.Condition.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "prop": "Product.Brand.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型",
      "prop": "Product.Model.Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "prop": "Product.Module.Name"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24ae6898"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Logistics/LogisticsDetailPage.vue
// module id = 710
// module chunks = 0